import React from "react";
import Select from "react-select";
import { COLORS } from "../../../../constants";
import { useHistoricoEntrega } from "../context/HistoricoEntregaContext";

interface LojaOption {
  value: number;
  label: string;
}

interface UsuarioOption {
  value: number;
  label: string;
}

const HistoricoEntregaFilters: React.FC = () => {
  const {
    startDate,
    endDate,
    selectedLojaId,
    selectedUsuarioId,
    setStartDate,
    setEndDate,
    setSelectedLojaId,
    setSelectedUsuarioId,
    handleApplyFilter,
    lojaOptions,
    usuarioOptions,
  } = useHistoricoEntrega();

  const selectedLojaOption = selectedLojaId
    ? lojaOptions.find((opt) => opt.value === selectedLojaId) || null
    : null;

  const selectedUsuarioOption = selectedUsuarioId
    ? usuarioOptions.find((opt) => opt.value === selectedUsuarioId) || null
    : null;

  const selectStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: "38px",
      fontSize: "0.875rem",
      borderColor: COLORS.NEUTRAL_300,
      "&:hover": { borderColor: COLORS.PRIMARY },
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected
        ? COLORS.PRIMARY
        : state.isFocused
          ? COLORS.NEUTRAL_100
          : COLORS.WHITE,
      color: state.isSelected ? COLORS.WHITE : COLORS.NEUTRAL_900,
    }),
  };

  return (
    <>
      <div className="mb-2">
        <h2 className="text-lg font-semibold text-neutral-800">
          Filtrar Histórico de Entrega
        </h2>
      </div>
      <div className="mb-6 rounded-lg bg-white p-4 shadow-md">
        <div className="flex flex-col items-stretch gap-4 sm:flex-row sm:items-end sm:gap-4">
          <div className="flex flex-col gap-1">
            <label
              htmlFor="start-date"
              className="text-xs font-medium text-neutral-700 sm:text-sm"
            >
              Data Início
            </label>
            <input
              id="start-date"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full rounded-lg border border-neutral-300 px-2 py-2 text-xs focus:border-transparent focus:ring-2 focus:ring-primary sm:w-auto sm:px-3 sm:text-sm"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label
              htmlFor="end-date"
              className="text-xs font-medium text-neutral-700 sm:text-sm"
            >
              Data Fim
            </label>
            <input
              id="end-date"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full rounded-lg border border-neutral-300 px-2 py-2 text-xs focus:border-transparent focus:ring-2 focus:ring-primary sm:w-auto sm:px-3 sm:text-sm"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label
              htmlFor="loja-select"
              className="text-xs font-medium text-neutral-700 sm:text-sm"
            >
              Loja
            </label>
            <Select<LojaOption>
              inputId="loja-select"
              value={selectedLojaOption}
              onChange={(option) => setSelectedLojaId(option?.value ?? null)}
              options={lojaOptions}
              isClearable
              placeholder="Todas"
              className="w-full sm:w-48"
              styles={selectStyles}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label
              htmlFor="usuario-select"
              className="text-xs font-medium text-neutral-700 sm:text-sm"
            >
              Entregador
            </label>
            <Select<UsuarioOption>
              inputId="usuario-select"
              value={selectedUsuarioOption}
              onChange={(option) => setSelectedUsuarioId(option?.value ?? null)}
              options={usuarioOptions}
              isClearable
              placeholder="Todos"
              className="w-full sm:w-48"
              styles={selectStyles}
            />
          </div>

          <button
            onClick={handleApplyFilter}
            className="w-full rounded-lg bg-primary px-3 py-2 text-xs font-medium text-white transition duration-200 hover:bg-primary-dark sm:w-auto sm:px-4 sm:text-sm"
          >
            Aplicar Filtro
          </button>
        </div>
      </div>
    </>
  );
};

export default HistoricoEntregaFilters;
